import { render, staticRenderFns } from "./chance-detail.vue?vue&type=template&id=46441774&scoped=true"
import script from "./chance-detail.vue?vue&type=script&lang=js"
export * from "./chance-detail.vue?vue&type=script&lang=js"
import style0 from "./chance-detail.vue?vue&type=style&index=0&id=46441774&prod&scoped=true&lang=scss"
import style1 from "./chance-detail.vue?vue&type=style&index=1&id=46441774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46441774",
  null
  
)

export default component.exports